import { render } from "./basic-related-tip.vue?vue&type=template&id=a94113b0&scoped=true"
import script from "./basic-related-tip.vue?vue&type=script&lang=js"
export * from "./basic-related-tip.vue?vue&type=script&lang=js"

import "./basic-related-tip.vue?vue&type=style&index=0&id=a94113b0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a94113b0"]])

export default __exports__